// Stimulus controllers are registered explicitly. Jekyll + Vite used `import.meta.glob`,
// which esbuild has no equivalent for; listing them keeps the identifiers identical to
// what the `data-controller` attributes in the templates expect.
import { Application } from '@hotwired/stimulus'
import ScrollTo from 'stimulus-scroll-to'

import AccountingDeadlinesController from './accounting_deadlines_controller'
import BytteguideController from './bytteguide_controller'
import CopyController from './copy_controller'
import DiscountCalculatorController from './discount_calculator_controller'
import EntrepreneurSchoolController from './entrepreneur_school_controller'
import ProfitMarginCalculatorController from './profit_margin_calculator_controller'
import SaftPriceController from './saft_price_controller'
import SidebarMenuController from './sidebar_menu_controller'
import VatCalculatorController from './vat_calculator_controller'

export function startStimulus() {
  const application = Application.start()

  application.register('scroll-to', ScrollTo)
  application.register('accounting-deadlines', AccountingDeadlinesController)
  application.register('bytteguide', BytteguideController)
  application.register('copy', CopyController)
  application.register('discount-calculator', DiscountCalculatorController)
  application.register('entrepreneur-school', EntrepreneurSchoolController)
  application.register('profit-margin-calculator', ProfitMarginCalculatorController)
  application.register('saft-price', SaftPriceController)
  application.register('sidebar-menu', SidebarMenuController)
  application.register('vat-calculator', VatCalculatorController)

  return application
}
